import { RootState } from "../types";

export const getUserIngridients = (state: RootState) => state.userIngridients;
